import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ViewAsBuyerState {
    isActive: boolean;
    buyerUserId: number | null;
    buyerName: string;
}

const initialState: ViewAsBuyerState = {
    isActive: false,
    buyerUserId: null,
    buyerName: '',
};

const viewAsBuyerSlice = createSlice({
    name: 'viewAsBuyer',
    initialState,
    reducers: {
        enterViewAsBuyer(
            state,
            action: PayloadAction<{ buyerUserId: number; buyerName: string }>
        ) {
            state.isActive = true;
            state.buyerUserId = action.payload.buyerUserId;
            state.buyerName = action.payload.buyerName;
        },
        exitViewAsBuyer(state) {
            state.isActive = false;
            state.buyerUserId = null;
            state.buyerName = '';
        },
    },
});

export const { enterViewAsBuyer, exitViewAsBuyer } = viewAsBuyerSlice.actions;
export default viewAsBuyerSlice.reducer;
